import { z } from "zod";

const cookieSchema = z.object({
  name: z.string(),
  value: z.string(),
  path: z.string(),
  domain: z.string().default("/"),
  secure: z.boolean().default(false),
  HttpOnly: z.boolean().default(false),
  SameSite: z.union([z.enum(["None", "Lax", "Strict"]), z.boolean()]),
  expires: z.string().optional(),
});

export function parseHeaderCookie(header: string) {
  // example - 'PHPSESSID=lajfaartsoolriokl1fu4ka4hc; path=/; domain=ariel.networx.link; secure; HttpOnly; SameSite=None'
  const cookie = Object.fromEntries(
    header
      .split(";")
      .map((el) => el.trim())
      .map((el, idx) => (idx === 0 ? [`name=${el.split("=")[0]}`, `value=${el.split("=")[1]}`] : el))
      .flat()
      .map((el) => el.split("="))
      .map((el) => (el.length === 1 ? [el[0], true] : el)),
  );
  return cookieSchema.parse(cookie);
}
